export const SEO_CONFIG = {
  // Configuration générale du site
  site: {
    name: 'Tours Bouillon',
    url: 'https://toursbouillon.fr',
    defaultImage: '/images/LOGO.jpg',
    phone: '+33247205060',
    email: 'toursbouillon@gmail.com',
    address: '6 rue des fusillés, 37000 Tours'
  },

  // Configuration par page
  pages: {
    home: {
      title: 'Accueil',
      description: 'Découvrez ToursBouillon, restaurant gastronomique à Tours. Cuisine française traditionnelle, ambiance chaleureuse et service d\'exception. Réservez votre table en ligne.',
      keywords: 'restaurant Tours, gastronomie Tours, cuisine française, restaurant centre-ville Tours, réservation restaurant, ToursBouillon',
      url: '/'
    },
    
    menu: {
      title: 'Notre Carte',
      description: 'Découvrez notre carte gastronomique : plats traditionnels français, vins d\'exception et desserts maison. Menu du jour, carte des vins et suggestions du chef.',
      keywords: 'menu restaurant Tours, carte gastronomique, plats français, vins Tours, menu du jour, cuisine traditionnelle',
      url: '/menu'
    },
    
    about: {
      title: 'À Propos',
      description: 'Découvrez l\'histoire du ToursBouillon, notre passion pour la gastronomie française et notre engagement pour une cuisine d\'exception au cœur de Tours.',
      keywords: 'histoire restaurant Tours, gastronomie Tours, cuisine française traditionnelle, restaurant Tours centre',
      url: '/about'
    },
    
    contact: {
      title: 'Contact',
      description: 'Contactez ToursBouillon pour vos réservations, événements privés ou questions. Nous sommes situés au 6 rue des fusillés à Tours.',
      keywords: 'contact restaurant Tours, réservation Tours, adresse restaurant Tours, téléphone restaurant',
      url: '/contact'
    },
    
    gallery: {
      title: 'Galerie',
      description: 'Découvrez l\'ambiance de ToursBouillon à travers notre galerie photos : nos plats, notre salle et les moments de convivialité.',
      keywords: 'photos restaurant Tours, ambiance restaurant, galerie photos Tours, restaurant Tours photos',
      url: '/gallerie'
    },
    
    reservation: {
      title: 'Réservation',
      description: 'Réservez votre table chez ToursBouillon en ligne. Service simple et rapide pour déjeuner ou dîner dans notre restaurant gastronomique.',
      keywords: 'réservation restaurant Tours, réserver table Tours, booking restaurant, réservation en ligne',
      url: '/reservation'
    },
    
    legal: {
      title: 'Mentions Légales',
      description: 'Mentions légales du restaurant ToursBouillon. Informations légales, propriété intellectuelle et responsabilité.',
      keywords: 'mentions légales ToursBouillon, restaurant Tours légal',
      url: '/mentions-legales'
    },
    
    privacy: {
      title: 'Politique de Confidentialité',
      description: 'Politique de confidentialité de ToursBouillon. Protection des données personnelles et respect du RGPD.',
      keywords: 'politique confidentialité ToursBouillon, RGPD restaurant',
      url: '/politique-confidentialite'
    }
  },

  // Schema.org pour les restaurants
  schema: {
    restaurant: {
      "@context": "https://schema.org",
      "@type": "Restaurant",
      "name": "ToursBouillon",
      "description": "Restaurant gastronomique à Tours, spécialisé dans la cuisine française traditionnelle",
      "url": "https://toursbouillon.fr",
      "telephone": "+33247205060",
      "email": "toursbouillon@gmail.com",
      "address": {
        "@type": "PostalAddress",
        "streetAddress": "6 rue des fusillés",
        "addressLocality": "Tours",
        "postalCode": "37000",
        "addressCountry": "FR"
      },
      "geo": {
        "@type": "GeoCoordinates",
        "latitude": 47.3900,
        "longitude": 0.6892
      },
      "openingHours": [
        "Tu-Sa 12:00-15:30",
        "Th-Fr 18:00-23:00"
      ],
      "servesCuisine": ["French", "Gastronomique"],
      "priceRange": "€€",
      "image": "https://toursbouillon.fr/images/LOGO.jpg"
    }
  }
};

// Fonction utilitaire pour obtenir la config d'une page
export const getPageSEO = (pageKey) => {
  return SEO_CONFIG.pages[pageKey] || SEO_CONFIG.pages.home;
}; 